/**
 * @license Copyright (c) 2003-2018, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

/**
 * @module image/imageinserturl/imageinserturlui
 */

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import imageIcon from '../theme/image-link.svg';
import ImageInsertCommand from './imageinsertcommand';

/**
 * The image insert by url button plugin.
 *
 * Adds the `'imageInsertUrl'` button to the {@link module:ui/componentfactory~ComponentFactory UI component factory}.
 *
 * @extends module:core/plugin~Plugin
 */
export default class ImageInsertUrlUI extends Plugin {
	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;
		const t = editor.t;

		// Setup `imageInsertUrl` button.
		editor.ui.componentFactory.add( 'imageInsertUrl', locale => {
			const view = new ButtonView( locale );
			
			const command = editor.commands.get( 'imageInsert' );
			view.bind( 'isEnabled' ).to( command );

			view.set( {
				label: t( 'Insert image by URL' ),
				icon: imageIcon,
				tooltip: true
			} );

			view.on( 'execute', () => {
                const imageURL = prompt( 'Image URL' );
                if(imageURL){
				    editor.execute('imageInsert', {source: imageURL});
                }
            } );

			return view;
		} );
		
		editor.commands.add( 'imageInsert', new ImageInsertCommand( editor ) );
	}
}
